<script setup>
// One component for every static public page (How it works / Pricing / About /
// Contact / Privacy / Terms). The copy is data (publicPages.js); this is layout.
import { computed } from "vue";
import { useRoute } from "vue-router";
import { PUBLIC_PAGES } from "./publicPages.js";

const route = useRoute();
const page = computed(() => PUBLIC_PAGES[route.meta?.page] || null);
</script>

<template>
  <section class="pp" v-if="page">
    <header class="pp-head">
      <h1>{{ page.title }}</h1>
      <p class="pp-lead">{{ page.lead }}</p>
    </header>

    <div class="pp-body">
      <section v-for="s in page.sections" :key="s.h">
        <h2>{{ s.h }}</h2>
        <p>{{ s.p }}</p>
      </section>
    </div>

    <p class="pp-cta">
      <router-link to="/" class="pp-back"><i class="bi bi-arrow-left me-1"></i>Browse the topics</router-link>
    </p>
  </section>
</template>

<style scoped>
/* Clearance under the overlaid header is handled centrally by PublicLayout
   (.pub-main.no-hero), so every hero-less page gets it — not just this one. */
.pp { max-width: 760px; margin: 0 auto; padding: 3.5rem 1.25rem 1rem; }
.pp-head { padding-bottom: 2rem; border-bottom: 1px solid #e8edf5; margin-bottom: 2.25rem; }
.pp h1 { margin: 0; font-size: clamp(2rem, 4vw, 2.75rem); font-weight: 800; letter-spacing: -.02em; color: #0f172a; }
.pp-lead { margin: .9rem 0 0; font-size: 1.15rem; line-height: 1.5; color: #475569; }
.pp-body section + section { margin-top: 2rem; }
.pp-body h2 { font-size: 1.15rem; font-weight: 700; color: #0f172a; margin: 0 0 .5rem; }
.pp-body p { margin: 0; font-size: 1.02rem; line-height: 1.65; color: #475569; }
.pp-cta { margin: 3rem 0 0; }
.pp-back { color: #2563eb; font-weight: 600; text-decoration: none; }
.pp-back:hover { text-decoration: underline; }
</style>
